 import Cookies from 'js-cookie';
import { useHistory } from 'react-router-dom';
import actions from './actions';

const { loginBegin, loginSuccess, loginErr, logoutBegin, logoutSuccess, logoutErr } = actions;
// const history = useHistory();
const login = () => {
  return async dispatch => {
    try {
      dispatch(loginBegin());
      setTimeout(() => {
        Cookies.set('logedIn', true);
        return dispatch(loginSuccess(true));
      }, 1000);
    } catch (err) {
      dispatch(loginErr(err));
    }
  };
};
  // const history = useHistory();

const logOut = () => {

  return async dispatch => {
    try {
      dispatch(logoutBegin());
      Cookies.remove('logedIn');

      dispatch(logoutSuccess(null));
      // history.push('/');

    } catch (err) {
      dispatch(logoutErr(err));
    }
  };
};

export { login, logOut };
